import React from "react";
import { Location, Message, Whatsapp } from "iconsax-react";
import { motion } from "framer-motion";
import "./contactPage.css";
import Navbar from "../../components/Navbar";
import WhatsAppFloatButton from "../../components/DialMenu/WhatsappFloatButton";

const ContactPage = () => {
  return (
    <>
      <Navbar />
      <motion.div
        className="contact-page text-[#5c4033] font-serif px-4 pt-24 pb-10 w-full"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
        style={{
          // backgroundImage: 'url("/gms.png")',
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          backgroundColor: "#fff",
        }}
      >
        <motion.h1
          className="text-3xl font-bold mb-5 drop-shadow-lg text-center"
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          Contact Us
        </motion.h1>

        <div className="w-full max-w-3xl mx-auto flex flex-col gap-9">
          {/* Google Maps */}
          <motion.div
            className="w-full rounded overflow-hidden shadow-lg"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            <iframe
              title="Lokasi Griya Alam Indah Cibubur"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3964.9009329831797!2d106.95350387505096!3d-6.40676219358399!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69952b95327ad1%3A0x2923fbb2202e5ab6!2sGriya%20Alam%20Indah%20Cibubur!5e0!3m2!1sen!2sid!4v1748323985026!5m2!1sen!2sid"
              width="100%"
              height="300"
              className="rounded"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </motion.div>

          {/* Kontak Info */}
          <motion.div
            className="flex flex-col space-y-6"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.6 }}
          >
            {/* Alamat */}
            <div className="contact-card w-full p-2 border-l-4 border-[#5c4033] flex items-start gap-3">
              <Location size="32" color="#5c4033" />
              <div>
                <h2 className="text-lg font-semibold mb-2">Address</h2>
                <p className="text-sm">
                  Griya Alam Indah Cibubur Blok C25, Cileungsi, Kab. Bogor 16820
                </p>
              </div>
            </div>

            {/* Email */}
            <div className="contact-card w-full p-2 border-l-4 border-[#5c4033] flex items-start gap-3">
              <Message size="32" color="#5c4033" />
              <div>
                <h2 className="text-lg font-semibold mb-2">Email</h2>
                <a
                  href="mailto:admin@gmsuksesindo.com"
                  className="text-sm hover:underline hover:text-[#008080]"
                >
                  admin@gmsuksesindo.com
                </a>
              </div>
            </div>

            {/* WhatsApp */}
            <div className="contact-card w-full p-2 border-l-4 border-[#5c4033] flex items-start gap-3">
              <Whatsapp size="32" color="#5c4033" />
              <div>
                <h2 className="text-lg font-semibold mb-2">WhatsApp</h2>
                <a
                  href="https://wa.me/6285265378528?text=Hai%20*PT.%20Gema%20Mitra%20Suksesindo*%2C%20saya%20ingin%20bertanya%20tentang%20produk%20Anda."
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm hover:underline hover:text-[#008080]"
                >
                  +62 852-6537-8528
                </a>
              </div>
            </div>
          </motion.div>
        </div>
      </motion.div>
      <WhatsAppFloatButton />
    </>
  );
};

export default ContactPage;
